import {Injectable} from '@angular/core';
import {OnAppInitInterface, Utils} from '@astek/utils';
import {BehaviorSubject, distinctUntilChanged, Observable, skip} from 'rxjs';

const DARK_THEME_STORAGE_KEY = 'darkTheme';

@Injectable()
export class ThemeService implements OnAppInitInterface {

  private _darkThemeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
  }

  public get darkTheme(): boolean {
    return this._darkThemeSubject.value;
  }

  public get darkThemeChanged(): Observable<boolean> {
    return this._darkThemeSubject.pipe(
      skip(1),
      distinctUntilChanged(),
    );
  }

  public onAppInit(): void {
    const darkTheme = localStorage.getItem(DARK_THEME_STORAGE_KEY);

    if (Utils.isNullOrUndefined(darkTheme)) {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
      if (prefersDark.matches) {
        this.toggleDarkTheme();
      }
      console.log('Theme initialized from user preference:', this.darkTheme ? 'dark' : 'light');
    } else {
      const storedDarkTheme = JSON.parse(darkTheme) as boolean;
      if (storedDarkTheme) {
        this.toggleDarkTheme();
      }
      console.log('Theme initialized from local storage:', this.darkTheme ? 'dark' : 'light');
    }

    this.storeTheme();
  }

  public toggleDarkTheme(): void {
    this._darkThemeSubject.next(!this.darkTheme);
    document.body.classList.toggle('dark-theme');
    this.storeTheme();
  }

  private storeTheme(): void {
    localStorage.setItem(DARK_THEME_STORAGE_KEY, JSON.stringify(this.darkTheme));
  }

}
